<template>
  <div id="feedbackModule">
    <div id="feedbacks" v-if="list">
      <v-container class="pa-0">
        <v-layout>
          <router-link to="/surveys/add">
          <v-flex class="xs12 sm12 mb-5">
            <v-btn fab absolute right class="mr-3 pf-btn-fab">
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
          </router-link>
        </v-layout>       
      </v-container>
      <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search by Family / PPN"
            single-line
            hide-details
          ></v-text-field>
      </v-card-title>
      <v-card class="mt-3">
        <v-data-table
          disable-initial-sort
          :headers="headers"
          :items="Survey"
          :search="search"
          :pagination.sync="pagination"
          class="pf-data-table"
        >
          <template v-slot:items="props">
            <td>{{ (props.item.account ? props.item.account.name : '') }}</td>
            <td>{{ (props.item.account ? props.item.account.ppn : '') }}</td>
            <td>{{ getRating(props.item.rating) }}</td>
            <td>{{ props.item.comment }}</td>
            <td>
              <v-select
                v-model="props.item.status"
                :items="statusList"
                height="30px"
                @change="statusUpdate(props.item)"
              ></v-select>
            </td>
            <td align="right">
              <v-btn icon class="ma-0" @click="editItem(props.item)">
                <v-icon size="22" color="grey darken-2">edit</v-icon>
              </v-btn>
               <v-btn icon class="ma-0" @click="deleteItem(props.item)">
                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div id="SurveyEdit" v-if="!list">
      <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="surveyEdit">
    <v-container class="-border">
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
          <v-flex class="xs12 sm6">
        <v-autocomplete
          prepend-icon="star"
          v-model="survey.account.id"
          @keyup="searchFamilies($event)" 
          :items="contactList"
          label="Family"
          hide-no-data
          placeholder="Search by Name / Nickname"
          hint="Type atleast 3 characters to search"
          :rules="[rules.toRule]"
          item-text="text"
          item-value="value"
          @change="selectedData=true"
          class="pr-4 pl-4">
        </v-autocomplete>
        </v-flex>
        </v-layout>
        <v-layout wrap class="pb-4 pt-3">
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" @change="selectedData=true" v-model="survey.explained_clearly" label="Was the profile process explained to you clearly ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" @change="selectedData=true" v-model="survey.meeting_ontime" label="Did your meeting start on the communicated date and time ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="No - but it was due to our conflict" color="success" value="No - but it was due to our conflict"></v-radio>
                <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" @change="selectedData=true" v-model="survey.helpful" label="Was the person that you worked with helpful in creating your profile ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group class="pr-4 pl-5" v-model="survey.communicate_clearly" @change="selectedData=true" label="Did the person that worked with you on your profile communicate clearly ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.overall_timelines" @change="selectedData=true" label="Were overall timelines communicated to you ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="Not Applicable" color="success" value="Not Applicable"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" v-model="survey.meet_timelines" @change="selectedData=true" label="Did we meet the timelines ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
                <v-radio label="No, because of our delay" color="success" value="No, because of our delay"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <v-radio-group :rules="required" prepend-icon="star" class="pr-4 pl-4 star" @change="selectedData=true" v-model="survey.rating" label="Overall satisfaction with profile creation process ?" column>
                <v-radio label="Wow it has been great !" color="success" value="5"></v-radio>
                <v-radio label="Very satisfied" color="success" value="4"></v-radio>
                <v-radio label="Satisfied" color="success" value="3"></v-radio>
                <v-radio label="Slightly satisfied" color="success" value="2"></v-radio>
                <v-radio label="Not satisfied" color="success" value="1"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="pr-4 pl-5 mt-4 v-label theme--light">Additional Feedback:</div>
              <v-textarea
              outline
              class="pr-4 pl-5 mt-3"
              name="input-7-4"
              label="Your feedback"
              no-resize
              height="175px"
              v-model="survey.additional_feedback"
              @click="selectedData=true"></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 v-if="survey.rating === '1' || survey.rating === '2'">
              <div class="pr-4 pl-5 mt-4 v-label theme--light">
                We apologize for not meeting your expectations. Your opinion is very valuable to us.
                Please let us know how we can improve the service or problems you ran into.
              </div>
            <v-textarea
            outline
            class="pr-4 pl-5 mt-3"
            no-resize
            height="175px"
            v-model="survey.satisfaction_feedback"
            @click="selectedData=true"></v-textarea>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="pr-4 pl-5 mt-4 v-label theme--light">What part of the process was the  easiest or most helpful ?</div>
            <v-textarea
            outline
            class="pr-4 pl-5 mt-3"
            label="Easiest or helpful"
            no-resize
            height="175px"
            v-model="survey.comment"
            @click="selectedData=true"></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 v-if="survey.rating === '1' || survey.rating === '2'">
              <v-radio-group class="pr-4 pl-5" v-model="isContact" label="Would you like someone to contact you ?" column>
                <v-radio label="Yes" color="success" value="Yes"></v-radio>
                <v-radio label="No" color="success" value="No"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6 v-if="(survey.rating === '1' || survey.rating === '2') && isContact === 'Yes'">
              <v-menu
                v-model="date.picker"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="FormattedDate"
                    :label="date.label"
                    hint="MM/DD/YYYY"
                    persistent-hint
                    readonly
                    clearable
                    prepend-icon="event"
                    @blur="survey.contact.date = parseDate(FormattedDate); selectedData = true"
                    v-on="on"
                    class="pr-4 pl-4"
                    @input="isFormDataChanged = true; selectedData = true"
                  ></v-text-field>
                </template>
                <v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="survey.contact.date" @input="date.picker = false"></v-date-picker>
              </v-menu>
              <v-menu
                  ref="menu"
                  v-model="time.picker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="survey.contact.time"
                      class="pr-4 pl-4"
                      :label="time.label"
                      prepend-icon="access_time"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="time.value"
                    full-width
                    @click:minute="time.picker = false"
                  ></v-time-picker>
                </v-menu>
                <v-text-field
                prepend-icon="star"
                v-mask="'(###) ###-####'"
                label="Phone Number" 
                v-model="survey.contact.phone"
                @input="selectedData=true"
                :rules="[rules.phoneRules]"
                class="pr-4 pl-4">
            </v-text-field>
            </v-flex>
        </v-layout>
    </v-container>
    <v-container class="pt-4">
      <v-layout>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    </v-form>
    </div>
  </div>
</template>
<script>
/* global session store config */
import { mask } from 'vue-the-mask';
import { getCollection, update, remove } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';

// This lists the surveys to the admin
export default {
  name: 'ListSurvey',
  directives: { mask },
  data: () => ({
    selectedData: false,
    list: true,
    search: '',
    entity: 'Survey',
    FormattedDate: null,
    isContact: '',
    date: {
      label: 'Date',
      value: null,
      picker: false
    },
    time: {
      label: 'Time',
      picker: false
    },
    survey: {},
    contactList: [],
    editIndex: -1,
    pagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: true,
      rowsPerPage: config.dom.rowsPerPage
    },
    rules: {
      toRule: (v) => !!v || 'Please select recipient',
      phoneRules: (v) => /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number',
    }, 
    required: [
      v => !!v || 'This option is required',
    ],
    query: {
      family: ''
    },
    familyList: [],
    statusList: ['Pending', 'Approved', 'Rejected'],
    headers: [
      { text: 'Family Name', value: 'account.name', align: 'left' },
      { text: 'PPN', value: 'account.ppn' },
      { text: 'Rating', value: 'rating', width: '160px' },
      { text: 'Comment', value: 'comment', width: '350px', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: '', width: '160px', sortable: false }
    ],
    ratingOptions: [{ text: 'Wow it has been great !', value: 5 },
      { text: 'Very satisfied', value: 4 },
      { text: 'Satisfied', value: 3 },
      { text: 'Slightly satisfied', value: 2 },
      { text: 'Not satisfied', value: 1 }],
  }),
  computed: {
    ...mapGetters(['Survey']),
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  watch: {
    'time.value' (newVal, oldVal) {
      if (newVal !== oldVal) {
        let hr = Number(newVal.split(':')[0]);
        let mi = Number(newVal.split(':')[1]);
        if (mi < 10) {
          mi = `0${mi}`;
        }
        if (hr > 12) {
          hr = hr - 12;
          if (hr < 10) (hr = `0${hr}`);
        }
        this.survey.contact.time = Number(newVal.split(':')[0]) > 12 ? `${hr}:${mi}pm` : `${newVal}am`;
      }
    },
    survey: {
      handler: function (after, before) {
        this.selectedData = true;
        if (after.contact) {
          this.FormattedDate = this.formatDate((after.contact.date));
        }
      },
      deep: true
    },
    handler: function () {
      if (!this.initializeFlag) {
        this.selectedData = true;
      } else {
        this.initializeFlag = false;
      }
    },
    deep: true
  }, 
  created () {
    this.initialize();
  },
  methods: {
    async searchFamilies (e) {
      this.familyList = [];
      this.contactList = [];
      this.query.family = e.target.value;
      let profile_number = this.query.family;
      let profile_year = this.query.family;
      if ((this.query.family && this.query.family.length && this.query.family.length > 2)) {
        let where = { };
        if (this.query.family && this.query.family.length > 2) {
          if (!where.$or) {
            where.$or = [{
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            }, {
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }, {
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }];
          } else {
            where.$or.push({
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            });
            where.$or.push({
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
          }
        }
        let populate = [{ 'path': 'human' }, 'contactInfo.country', 'contactInfo.state'];
        let { error, data } = await getCollection('Account', true, 0, populate, where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            this.familyList = data;
            this.families();
          } else {
            this.families();
          }
        }
      }
    },
    // @vuese
    // Used to create the contact list from the family list
    async families () {
      this.familyList.forEach(item => {
        let obj = {
          text: item.name,
          value: item.id
        };
        this.contactList.push(obj);
      });
    },
    // @vuese
    // Used to show the form buttons
    changedData () {
      this.selectedData = true;
    },
    // @vuese
    // Used to hide the form buttons
    hideButtons () {
      window.getApp.$emit('pageSubHeader', '');
      this.selectedData = false;
      this.list = true;
    },
    // @vuese
    // Used to update the survey status
    // @arg The survey object to be updated
    async statusUpdate (item) {
      let updateItem = JSON.parse(JSON.stringify(item));
      updateItem.account = updateItem.account.id;
      let itemIndex = this.Survey.indexOf(item);
      let updateId = this.Survey[itemIndex].id;
      let { error, data, status } = await update(this.entity, updateItem, updateId);
      if (error) {
        console.log('error', error);
        swal.fire({
          type: 'error',
          title: 'Failed to update data',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {}
        });
      } else {
        swal.fire(
          'Updated!',
          'The Survey status been updated.',
          'success'
        );
      }
    },
    // @vuese
    // Used to go back to the survey list
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.list = true;
      this.editIndex = -1;
      this.survey = {};
    },
    // @vuese
    // Used to setup the survey edit
    // @arg The survey item object to be edited
    editItem (item) {
      this.editIndex = this.Survey.indexOf(item);
      this.list = false;
      this.survey = JSON.parse(JSON.stringify(item));
      if (this.survey.contact && this.survey.contact.phone) {
        this.isContact = 'Yes';
      } else {
        this.survey.contact = {
          date: '',
          time: '',
          phone: null
        };
      }
      if (this.survey.contact && this.survey.contact.date) {
        this.survey.contact.date = (this.survey.contact.date).substr(0, 10);
      }
      this.survey.rating = `${this.survey.rating}`;
      window.getApp.$emit('pageSubHeader', 'Edit');
      this.contactList.push({
        text: this.survey.account.name,
        value: this.survey.account.id
      });
    },
    // @vuese
    // Used to fetch the survey list if not exists
    async initialize () {
      if (!this.Survey.length) {
        let sort = { 'createdAt': -1 };
        let where = { 'status': { '$in': ['Pending', 'Approved', 'Rejected'] }};
        let { error, data } = await getCollection(this.entity, true, 0, '', where, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setSurvey', data);
          }
        }
      }
    },
    // @vuese
    // Used to get the rating text
    getRating (ratingValue) {
      let result = this.ratingOptions.find(item => item.value === ratingValue);
      return result.text;
    },
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let { error, data, status } = await remove('Survey', item.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.Survey.indexOf(item);
              this.Survey.splice(index, 1);
              swal.fire(
                'Deleted!',
                'The Survey has been deleted.',
                'success'
              );
            }
          })();
        }
      });
    },
    formatDate (date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate (date) {
      if (!date) return '';
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    // @vuese
    // Used to save the edited Survey
    async save () {
      if (this.$refs.surveyEdit.validate()) {
        console.log(this.isContact);
        this.selectedData = false;
        this.survey.rating = Number(this.survey.rating);
        if (!this.survey.contact.phone) {
          delete this.survey.contact;
        } else if (this.survey.contact) {
          if (!this.survey.contact.date) {
            delete this.survey.contact.date;
          }
          if (!this.survey.contact.time) {
            delete this.survey.contact.time;
          }
        }
        let postData = {
          account: this.survey.account.id,
          explained_clearly: this.survey.explained_clearly,
          meeting_ontime: this.survey.meeting_ontime,
          helpful: this.survey.helpful,
          communicate_clearly: this.survey.communicate_clearly,
          overall_timelines: this.survey.overall_timelines,
          meet_timelines: this.survey.meet_timelines,
          rating: this.survey.rating,
          comment: this.survey.comment ? this.survey.comment : '',
          contact: this.isContact === 'Yes' ? this.survey.contact : {}
        };
        let { error, data } = await update('Survey', postData, this.survey.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.Survey[this.editIndex] = data;
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Survey updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.editIndex = -1;
              this.list = true;
              this.survey = {};
              window.getApp.$emit('pageSubHeader', '');
            }
          });
        }
      }
    }
  }
};
</script>
<style scoped>

#feedbackModule >>> .v-input__prepend-outer .v-icon.material-icons {
  font-size: 0.6rem;
  color: red !important;
}

#feedbackModule >>> .v-input--is-readonly .v-input__prepend-outer .v-icon.material-icons {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.54) !important;
}

#feedbackModule >>> .v-input__prepend-outer {
  margin-right: 0;
}

</style>



// WEBPACK FOOTER //
// src/pages/Surveys/list.vue